import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core'

import { StepComponent } from './step/step.component'

@Component({
	selector: 'mv-stepper',
	templateUrl: './stepper.component.html',
	styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements AfterContentInit {
	@ContentChildren('mvStep') steps!: QueryList<StepComponent>

	constructor () { }

	ngAfterContentInit (): void {
		if (!!this.steps.length) {
			this.steps.forEach(s => s.ariaLabel = `Step ${s.step} of ${this.steps.length} - ${s.ariaLabel}`)
		}
	}

}
